import type { DeepPartial } from '@luna/utils-ts';

import type { Documents } from '../../types/Documents';

export const documentsSKFeatureConfig: DeepPartial<Documents> = {
    requestForTitleDocuments: true,
};
